import store from '@/store'

class PingWatcher {
  constructor(timeout) {
    this.timeout = timeout;
    this.interval = null;
  }

  startWatch() {
    if (this.timeout && !this.interval) {
      this.interval = setInterval(function () {
        store.dispatch('core/ping').catch(() => {
        })
      }, this.timeout)
    }
  }

  stopWatch(){
    if( this.interval ){
      clearInterval(this.interval)
      this.interval=null;
    }
  }
}

export default new PingWatcher(parseInt(process.env.VUE_APP_PING_WATCHER_TIMOUT));
